import { Component } from 'react';
import { TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

const CustomTextField = styled(TextField)(({ theme }) => ({
    "& .MuiOutlinedInput-notchedOutline legend": { 
        display: "none", 
    }
}));

class CustomizedTextField extends Component {

    handleKeyDown(event) {
        if ((!this.props.multiline && event.keyCode === 13 /*enter*/) || event.keyCode === 27 /*esc*/) {
            event.target.blur();
        }
    }

    render() {        
        return (this.props.label ?
            <TextField error={this.props.error} autoComplete="off" onKeyDown={this.props.handleKeyDown ? this.props.handleKeyDown : this.handleKeyDown.bind(this)} {...this.props} />
            :
            <CustomTextField error={this.props.error} autoComplete="off" onKeyDown={this.props.handleKeyDown ? this.props.handleKeyDown : this.handleKeyDown.bind(this)} {...this.props} />)
    }
}

export default (CustomizedTextField);
